<template>

	<!-- VideoPlayer -->
	<div id="divVideoPlayer" class="videoContainer"></div>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'
import $ from 'jquery'

export default {
	name: "VideoPlayer",
	props: {
		autoPlay: Boolean,
		showControls: Boolean,
		start: String,
		resolution: String,
		url: String
	},
	data() {
		return {
			// autoPlay: false,
			// showControls: false,
			// start: null,
			// resolution: null,
			// theVideoUrl: null
		}
	},

	beforeCreate() {
		Logger.log("VideoPlayer.vue beforeCreate");

		// we only need DASH if not iOS
		if (!this.$root.device.ios) {
			if (process.env.NODE_ENV === "production")
				require("@/assets/scripts/dash.all.min.js");
			else
				require("@/assets/scripts/dash.all.debug.js");
		}
	},
	created() {
		Logger.log("VideoPlayer.vue created");
	},
	beforeMount() {
		Logger.log("VideoPlayer.vue beforeMount");
	},
	mounted() {
		Logger.log("VideoPlayer.vue mounted ");

		this.createVideoPlayer();
	},
	beforeUpdate() {
		Logger.log("VideoPlayer.vue beforeUpdate");
	},
	updated() {
		Logger.log("VideoPlayer.vue updated");
	},
	beforeDestroy() {
		Logger.log("VideoPlayer.vue beforeDestroy");
	},
	destroyed() {
		Logger.log("VideoPlayer.vue destroyed");
	},

	methods: {
		createVideoPlayer() {
			var playerInit = {
				debug : true,
				initialShowControls : true,
				iOS : this.$root.device.ios || this.$root.device.mac,
				noContent : this.$t("message.noContent"),
				reportErrors : false,
				titleChaptersButton : this.$t("videoPlayer.chaptersBtn"),
				titleCloseAnnotationButton : this.$t("videoPlayer.closeAnnotationBtn"),
				titleExitFullscreenButton : this.$t("videoPlayer.exitFullscreenBtn"),
				titleFullscreenButton : this.$t("videoPlayer.fullscreenBtn"),
				titleMuteButton : this.$t("videoPlayer.muteBtn"),
				titlePauseButton : this.$t("videoPlayer.pauseBtn"),
				titlePlayButton : this.$t("videoPlayer.playBtn"),
				titleReplayButton : this.$t("videoPlayer.replayBtn"),
				titleResolutionButton : this.$t("videoPlayer.resolutionBtn"),
				titleResolutionMenu : this.$t("videoPlayer.titleResolutionMenu"),
				titleUnmuteButton : this.$t("videoPlayer.unmuteBtn"),
				typeNotSupported : this.$t("message.typeNotSupported"),
				videoNotSupported : this.$t("message.videoNotSupported"),
				data : {}
			};

			// auto play
			if (this.$props.autoPlay) {
				playerInit.autoPlay = true;
			}

			// always show controls
			if (this.$root.device.iphone || this.$props.showControls) {
				playerInit.alwaysShowControls = true;
			}

			// set start time
			if (parseInt(this.$props.start)) {
				playerInit.data.lastWatchedPosition = parseInt(this.$props.start);
			}

			// set start resolution
			if (this.$props.resolution) {
				playerInit.startResolution = this.$props.resolution;
			}

			// set video url
			if (this.$props.url) {

				// first look for encrypted links (V2K shared lessons)
				var encLink, qParam;
				// read query string parameter 'play'
				if ((encLink = this.getQueryParameter("play"))) {
					qParam = "play";
				}
				// read query string parameter 'enc'
				else if ((encLink = this.getQueryParameter("enc"))) {
					qParam = "enc";
				}

				// ------------------------------------------------------------
				// encrypted link:  get video urls from lesson data service
				// ------------------------------------------------------------

				if (encLink) {
					var url = "{0}?{1}={2}".format(process.env.VUE_APP_LESSONDATA_SERVICE_URL, qParam, encLink);
					window.jQuery.ajax(url, {
						dataType: "json",
					}).done((json) => {
						Logger.log("success: " + url);
						// check object state
						if (json.state.toLowerCase() === "okay") {

							// is video lesson?
							if (json.data.videoPlayerData) {
								var videoPlayerData = json.data.videoPlayerData;

								// check for start time query parameter
								var startTimeParam = this.getQueryParameter("startTime");
								if (startTimeParam) {
									playerInit.data.lastWatchedPosition = parseInt(startTimeParam);
								}

								// cookies
								var cookies = json.data.cookies;
								if (cookies) {
									for (var i = 0 ; i < cookies.length ; i++) {
										var cookie = cookies[i],
											attrs = {'Max-Age': cookie.maxAge, 'Domain': cookie.domain, 'Path': cookie.path};
										// remove old cookie
										this.$cookie.delete(cookie.name);
										// set new cookie
										if (process.env.VUE_APP_MODE !== "local") {
											attrs.SameSite = "None";
											attrs.Secure = true;
										}
										this.$cookie.set(cookie.name, cookie.value, attrs);
									}
								}

								// video urls
								if (videoPlayerData.videoUrls) {
									playerInit.data.videoUrls = videoPlayerData.videoUrls;

									// annotations
									if (videoPlayerData.annotations) {
										playerInit.data.annotations = videoPlayerData.annotations;
									}

									// subtitles
									if (videoPlayerData.subtitleUrls) {
										playerInit.data.subtitleUrls = videoPlayerData.subtitleUrls;
									}
								}

								$("#divVideoPlayer").videoPlayer(playerInit);
							}
						}
						else {
							var error = "GET lessonData service return state '{0}':  {1}".format(json.state, json.msgCode);
							Logger.log("exception occurred:\n\t" + error, "url: " + url);
							$("#divVideoPlayer").empty().append($("<p/>").addClass("failMessageBlock").text(error));
						}
					}).fail((jqxhr, textStatus, error) => {
						var msg = "error: ";
						if (textStatus) {
							msg += textStatus;
							if (error)
								msg += ", " + error;
						}
						else if (error) {
							msg += error;
						}
						Logger.log(msg);
						$("#divVideoPlayer").empty().append($("<p/>").addClass("failMessageBlock").text(msg));
					}).always(function() {
						Logger.log("complete: " + url);
					});
				}

				// ------------------------------------------------------------
				// direct link to video file
				// ------------------------------------------------------------

				else {

					var ndx, type;
					if ((ndx = this.$props.url.lastIndexOf('.')) > 0) {
						type = this.$props.url.substr(ndx + 1);
						switch (type.toLowerCase()) {
						case "mpd":
							// check for DASH support
							if (this.isIosDevice() || (this.$root.device.mac && this.$root.browser.name == "safari")) {
								type = null;
							}
							else {
								type = "application/dash+xml";
							}
							break;
						case "m3u8":
							type = "application/vnd.apple.mpegurl";
							break;
						default:
							type = "video/mp4";
						}

						if (type) {
							playerInit.data.videoUrls = [{
								type : type,
								url : this.$props.url
							}];
						}
						else {
							$("#divVideoPlayer").empty().append($("<p/>").addClass("failMessageBlock").text(this.$t("message.typeNotSupported")));
							return;
						}
					}

					$("#divVideoPlayer").videoPlayer(playerInit);
				}
			}
		},
		getQueryParameter(param) {
			var results = new RegExp("[?&]{0}=([^&#]*)".format(param)).exec(this.$props.url),
				val = null;
			if (results) {
				val = results[1] || null;
			}
			return val;
		},
		// update(url, autoPlay, showControls, start, resolution) {
		// 	this.theVideoUrl = url;
		// 	this.autoPlay = autoPlay;
		// 	this.showControls = showControls;
		// 	this.start = start;
		// 	this.resolution = resolution;

		// 	this.createVideoPlayer();
		// },
		isIosDevice() {
			return this.$root.device.ios || (this.$root.device.mac && (typeof window.orientation !== "undefined"));
		}
	}
}
</script>

<style lang="scss" scoped>

	#divVideoPlayer {

		// override vuetify styling
		::v-deep p {
			margin: 0;
		}
	
	}

</style>
